import React from 'react'
import icon from '../../img/icon/logo.png';

export default function Logo() {
   return (
      <div>
         <img src={icon} alt="" />
      </div>
   )
}
